const removeAuth = () =>{
    localStorage.removeItem('userData')
    localStorage.removeItem('accessToken');
    localStorage.removeItem('total_time')
    localStorage.removeItem('tracker');
    localStorage.removeItem('project_id')
    localStorage.removeItem('task_id');
    localStorage.removeItem('total_task_time');
    localStorage.removeItem('start_timestamp');
    
  }
  export {removeAuth}